var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0304 22.2244L18.2915 24.268C17.9325 24.5358 17.7195 24.9547 17.7154 25.4011C17.7112 25.8475 17.9165 26.2703 18.2705 26.5446L22.3423 29.7002C22.875 30.1131 23.6268 30.1476 24.1975 29.7841C24.7875 29.4082 25.0462 28.7067 24.8458 28.0566C24.8458 28.0566 23.818 24.7228 23.2717 22.9506C23.1341 22.5045 22.7867 22.1529 22.3407 22.0083C21.8946 21.8638 21.4057 21.9444 21.0304 22.2244Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7581 1.87679L11.1466 10.5208C11.1113 10.6376 10.9938 10.7095 10.8672 10.7092L2.16829 10.6889C1.51128 10.6874 0.929999 11.0921 0.711111 11.6872C0.487141 12.2962 0.682729 12.9762 1.20679 13.3808L8.41655 18.9466C8.49559 19.0076 8.53345 19.1067 8.50484 19.2001L5.77734 28.0944C5.58181 28.732 5.83416 29.4202 6.40985 29.7889C6.96669 30.1455 7.70027 30.1116 8.22005 29.7066C10.4644 27.958 26.9634 15.163 29.272 13.3808C29.7961 12.9762 29.9917 12.2962 29.7677 11.6872C29.5488 11.0921 28.9676 10.6874 28.3106 10.6889L19.6117 10.7092C19.485 10.7095 19.3676 10.6376 19.3323 10.5208C18.8545 8.93922 17.5892 4.75155 16.7207 1.87679C16.5286 1.2411 15.9285 0.79541 15.2394 0.79541C14.5504 0.79541 13.9503 1.2411 13.7581 1.87679Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartFill);
export default __webpack_public_path__ + "static/media/start-fill.5073bf9040c443ba3485d4a253b1b969.svg";
export { ForwardRef as ReactComponent };